<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt width="25" height="25" />
      <p class="title-bk">法人登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'corporation' }">戻る</router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submitForm)" ref="form">
          <table class="table table-form">
            <tbody>
              <IdInputField
                v-model="currentCorporation.uid"
                extraRules="required"
                label="法人ID"
                placeholder="半角英数字で入力してください（-、_は可）"
                inputClass="col-lg-6"
                resourceType="corporation"
              />
              <PasswordField vid="password" v-model="currentCorporation.password" extraRules="required" />
              <PasswordField
                v-model="verifyPassword"
                extraRules="required|verify_password:password"
                label="パスワード（確認）"
              />
              <br />
              <TextField v-model="currentCorporation.name" label="法人名" placeholder="" extraRules="required" />
              <TextField
                v-model="currentCorporation.nameReading"
                label="法人名（フリガナ）"
                placeholder="全角カタカナ"
                extraRules="required"
              />
              <PostalCodeField
                v-model="currentCorporation.postalCode"
                @fillAddresses="fillAddresses($event)"
                extraRules="required"
                inputClass="col-lg-4"
              />
              <TextField
                v-model="currentCorporation.state"
                label="都道府県 市区町村"
                placeholder="例）京都府京都市中京区笋町"
                extraRules="required"
              />
              <TextField
                v-model="currentCorporation.address"
                label="番地・建物名"
                placeholder="例）688 第15長谷ビル5F"
                extraRules="required"
              />
              <TextField
                v-model="currentCorporation.phone"
                extraRules="phone_number|required"
                label="電話番号"
                placeholder="例）075-708-8100"
              />

              <TextField
                v-model="currentCorporation.fax"
                extraRules="phone_number"
                label="FAX番号"
                placeholder="例）075-708-8101"
              />
              <TextField
                v-model="currentCorporation.email"
                extraRules="email"
                label="メールアドレス"
                placeholder="例）sample@tamaishiki.com"
              />
              <ProductField v-model="currentCorporation.figuredProducts" :options="product.products" />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import TextField from '@/components/forms/TextField.vue';
import PostalCodeField from '@/components/forms/PostalCodeField.vue';
import PasswordField from '@/components/forms/PasswordField.vue';
import IdInputField from '@/components/forms/IdInputField.vue';
import ProductField from '@/components/forms/ProductField.vue';

export default {
  data() {
    return {
      verifyPassword: '',
      currentCorporation: {},
    };
  },
  components: {
    ValidationObserver,
    IdInputField,
    TextField,
    PostalCodeField,
    PasswordField,
    ProductField,
  },
  computed: {
    ...mapState(['corporation']),
    ...mapState(['product']),
  },
  async created() {
    this.currentCorporation = this.createFreshCorporationObject();
    await this.fetchProducts();
  },
  methods: {
    createFreshCorporationObject() {
      if (this.corporation.editingCorporation) {
        this.$logger.debug('Editing old Corporation with ID ' + this.corporation.editingCorporation);
        return this.corporation.editingCorporation;
      } else {
        return {
          uid: '',
          name: '',
          nameReading: '',
          postalCode: '',
          state: '',
          address: '',
          phone: '',
          email: null,
          password: '',
          figuredProducts: [],
        };
      }
    },
    submitForm() {
      this.$logger.debug('Started Adding: ' + JSON.stringify(this.currentCorporation));
      this.startEditingCorporation(this.currentCorporation);
      this.$router.push({ name: 'corporation-confirm' });
    },
    fillAddresses(addressComponents) {
      this.$logger.debug('addressComponents', addressComponents);
      this.currentCorporation.state = addressComponents.city_state;
      this.currentCorporation.address = addressComponents.address;
    },
    ...mapActions('corporation', ['startEditingCorporation']),
    ...mapActions('product', ['fetchProducts']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
